import { ApplicationState } from 'application/redux';
import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import { cancelCommand, fetch, fetchSpeedTest } from './redux/actions';
import SpeedTestComponent from './speed-test-component';

function mapStateToProps(state: ApplicationState, ownProps: any) {
  return {
    speedTest: state.devices.detail.speedTest,
    general: state.devices.detail.general,
    search: state.search,
    id: ownProps.id,
    t: state.i18n.t
  };
}

export default connect(mapStateToProps, {
  onSearch: fetch,
  onStartSpeedTest: fetchSpeedTest,
  cancelCommand,
  executeCommand,
})(SpeedTestComponent);
